export const HUB_CONTAINER_ID = "hubContainer";

export const TEXT_SIZE_CONTROL_BOTTOM_LIMIT = 1;
export const TEXT_SIZE_CONTROL_UPPER_LIMIT = 999;
